import React from "react";
import Currency from "../../Components/Currency/Currency.js";
import NewFooter from "../../Components/Footer/NewFooter.js";
import BenifitsOfInvesting from "../../Components/GettingStarted/BenifitsOfInvesting.js";
import GettingStarted from "../../Components/GettingStarted/GettingStarted.js";
import WeServe from "../../Components/GettingStarted/WeServe.js";
import HomeHero1 from "../../Components/Hero/HomeHero1.js";
import LandingPgHero from "../../Components/Hero/LandingPgHero.js";
import OurMarketPlace from "../../Components/Marketplace/OurMaketPlace.js";
import Tokenization from "../../Components/Tokenization/Tokenization.js";
import { LoginModal } from "../../Components/Modal/LoginModal.js";
import { SignupModal } from "../../Components/Modal/SignupModal.js";
import { ForgotPassword } from "../../Components/Modal/ForgotPasswordModal.js";
import { ResetPassword } from "../../Components/Modal/ResetPassowrdCard.js";
import VerificationModal from "../../Components/Modal/VerificationModal.js";
import { useDisclosure } from "@chakra-ui/react";
import LandingPgHeader from "../../Components/Header/LandingPgHeader.js";

function HomeScreen() {
    const { isOpen: isOpenLoginModal, onClose: onCloseLoginModal, onOpen: onOpenLoginModal } = useDisclosure()
    const { isOpen: isOpenSignupModal, onClose: onCloseSignupModal, onOpen: onOpenSignupModal } = useDisclosure()
    const { isOpen: isOpenForgotPasswordModal, onClose: onCloseForgotPasswordModal, onOpen: onOpenForgotPasswordModal } = useDisclosure()
    const { isOpen: isOpenResetPasswordModal, onClose: onCloseResetPasswordModal, onOpen: onOpenResetPasswordModal } = useDisclosure()
    const { isOpen: isOpenVerificationModal, onClose: onCloseVerificationModal, onOpen: onOpenVerificationModal } = useDisclosure()

    return (
        <>  
            <LandingPgHero onOpenLoginModal={onOpenLoginModal} />
            <OurMarketPlace />
            <Tokenization onOpenLoginModal={onOpenLoginModal} />
            <GettingStarted onOpenLoginModal={onOpenLoginModal} />
            <Currency />
            <HomeHero1 />
            <WeServe />
            <BenifitsOfInvesting />
            <NewFooter />

            {/* MODALS */}
            <LoginModal
                isOpen={isOpenLoginModal}
                onClose={onCloseLoginModal}
                onOpenSignupModal={onOpenSignupModal}
                onOpenForgotPasswordModal={onOpenForgotPasswordModal}
            />
            <SignupModal
                isOpen={isOpenSignupModal}
                onClose={onCloseSignupModal}
                onOpenLoginModal={onOpenLoginModal}
            />
            <ForgotPassword
                isOpen={isOpenForgotPasswordModal}
                onClose={onCloseForgotPasswordModal}
                onOpenLoginModal={onOpenLoginModal}
                onOpenVerificationModal={onOpenVerificationModal}
            />
            <ResetPassword
                isOpen={isOpenResetPasswordModal}
                onClose={onCloseResetPasswordModal}
                onOpenLoginModal={onOpenLoginModal}
                onOpenForgotPasswordModal={onOpenForgotPasswordModal}
            />
            <VerificationModal
                isOpen={isOpenVerificationModal}
                onClose={onCloseVerificationModal}
                onOpenLoginModal={onOpenLoginModal}
                onOpenResetPasswordModal={onOpenResetPasswordModal}
            />
        </>
    );
}

export default HomeScreen;
